<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" >
        <slot></slot>
      </div>
    </template>

    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        {{$t('menus.resourceLimits.resourceLimits')}}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

        <v-card-text scrollable class="scrollable">
          <ResourceLimitItem
            v-model="usersItems"
            v-bind:label="$t('menus.resourceLimits.users')"
            v-model:limitObject="getUsersLimits"
            v-model:addonObject="getUserAddon"
            v-bind:disableTeamUsers="true"
            filter=""
            class="mb-5"
          >
          </ResourceLimitItem>

          <ResourceLimitItem
            v-model="clientuserItems"
            v-bind:label="$t('menus.resourceLimits.clientusers')"
            v-model:limitObject="getClientuserLimit"
            v-model:addonObject="getClientuserAddon"
            filter=""
            class="mb-5"
          >
          </ResourceLimitItem>

          <ResourceLimitItem
            v-model="storageItems"
            v-bind:label="$t('menus.resourceLimits.storage')"
            v-model:limitObject="getStorageLimits"
            v-model:addonObject="getStorageAddon"
            filter="prettyBytes"
            class="mb-5"
          >
          </ResourceLimitItem>

          <ResourceLimitItem
            v-model="bandwidthItems"
            v-bind:label="$t('menus.resourceLimits.bandwidth')"
            v-model:limitObject="getBandwidthLimit"
            v-model:addonObject="getBandwidthAddon"
            filter="prettyBytes"
            class="mb-5"
          >
          </ResourceLimitItem>

          <ResourceLimitItem
            v-model="creditItems"
            v-bind:label="$t('menus.resourceLimits.credits')"
            v-model:limitObject="getCreditsLimit"
            v-model:addonObject="getCreditsAddon"
            filter=""
            class="mb-5"
          >
          </ResourceLimitItem>


          <!-- <ResourceLimitItem
            v-model="transcriptItems"
            v-bind:label="$t('menus.resourceLimits.transcript')"
            v-bind:limitObject.sync="getTranscriptLimits"
            v-bind:addonObject.sync="getTranscriptAddon"
            filter="videoDuration"
            class="mb-5"
          >
          </ResourceLimitItem> -->

          <!-- <ResourceLimitItem
            v-model="translateItems"
            v-bind:label="$t('menus.resourceLimits.translate')"
            v-bind:limitObject.sync="getTranslateLimits"
            v-bind:addonObject.sync="getTranslateAddon"
            filter="toKilo"
            class="mb-5"
          >
          </ResourceLimitItem> -->

          <!-- <ResourceLimitItem
            v-model="rekognitionItems"
            v-bind:label="$t('menus.resourceLimits.rekognition')"
            v-bind:limitObject.sync="getRekognitionLimit"
            v-bind:addonObject.sync="getRekognitionAddon"
            filter="videoDuration"
            class="mb-5"
          >
          </ResourceLimitItem> -->

          <div v-if="isInTrialPeriod" class="mb-5 bg-error">
            {{$t('menus.resourceLimits.cannotBuyInTrial')}}
          </div>

        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn elevation=0 color="primary" v-bind:disabled="isSubmitDisabled" v-on:click="showAddonsDialog = true" class="mr-2">
            {{$t('menus.resourceLimits.openSummaryView')}}
          </v-btn>

          <BuyAddonsDialog
              v-model="showAddonsDialog"
              v-model:disabled="isSubmitDisabled"
              v-model:usersItems="usersItems"
              v-model:storageItems="storageItems"
              v-model:bandwidthItems="bandwidthItems"
              v-model:clientuserItems="clientuserItems"
              v-model:creditItems="creditItems"
              v-on:resetQuantity="resetQuantity"
          >
          </BuyAddonsDialog>

          <v-btn variant="text" @click="dialog = false" data-cy="dialog-------">{{$t('common.cancel')}}</v-btn>
        </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import { useNodeStore } from '@/stores/NodeStore.js';
import { useSystemStore } from '@/stores/SystemStore.js'
import { useServiceStore } from '@/stores/ServiceStore.js'
import BuyAddonsDialog from './BuyAddonsDialog.vue'
import ResourceLimitItem from '../components/ResourceLimitItem.vue'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "ResourcesListDialog",
  components: {
    BuyAddonsDialog,
    ResourceLimitItem
  },
  data() {
    return {
      dialog: false,

      showAddonsDialog: false,

      usersItems: 0,
      clientuserItems: 0,
      storageItems: 0,
      bandwidthItems: 0,
      creditItems: 0,
      // transcriptItems: 0,
      // translateItems: 0,
      // rekognitionItems: 0,

    };
  },
  // mounted: function() {
  // },
  watch: {
    currentNode: function() {
      this.refreshSubscription();
    },
    dialog(newValue) {
      if(newValue) {
        this.resetQuantity();
        this.refreshLimits();
        this.refreshSubscription();
      }
    }
  },
  methods: {
    showMenu: function(componentName) {
      const mainStore = useMainStore();
      mainStore.setActiveMenu(componentName);
    },
    refreshLimits() {
      const payload = {
        accessPointId: this.accessPointId
      };

      const serviceStore = useServiceStore();
      serviceStore.refreshLimits(payload);
    },
    refreshSubscription: function() {
      if (!this.currentNode || !this.currentNode.id) {
        return;
      }

      const contextNodeId = this.currentNode.id;

      const systemStore = useSystemStore();
      systemStore.refreshSubscription(contextNodeId);
    },
    resetQuantity: function() {
      this.usersItems = 0;
      this.clientuserItems = 0;
      this.storageItems = 0;
      this.bandwidthItems = 0;
      this.creditItems = 0;
      // this.transcriptItems = 0;
      // this.translateItems = 0;
      // this.rekognitionItems = 0;
    },
    getResouceStructure: function() {
      return {
        limit: 0,
        usage: 0,
        percentage: 0,
      }
    },

  },
  computed: {
    accessPointId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getLimits: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getLimits;
    },
    currentNode: function() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    getSubscription: function() {
      const systemStore = useSystemStore();
      return systemStore.getSubscription;
    },

    getLimitByName() {
      return (limitName) => {
        let resource = this.getResouceStructure();

        if (!Array.isArray(this.getLimits)) {
          return resource;
        }

        let limit = this.getLimits.find(x => x.name == limitName);
        if (limit) {
          resource.limit = limit.limit;
          resource.usage = limit.spent;
          resource.percentage = limit.limit == 0 ? 0 : (limit.spent / limit.limit);
          resource.percentage = (resource.percentage * 100).toFixed(1);
        }

        return resource;
      };
    },


    getUsersLimits: function() {
      return this.getLimitByName('users');
    },
    getClientuserLimit: function() {
      return this.getLimitByName('clientuser');
    },
    getStorageLimits: function() {
      return this.getLimitByName('storage');
    },
    getBandwidthLimit: function() {
      return this.getLimitByName('bandwidth');
    },
    getCreditsLimit: function() {
      return this.getLimitByName('credits');
    },
    // getTranscriptLimits: function() {
    //   return this.getLimitByName('transcription');
    // },
    // getTranslateLimits: function() {
    //   return this.getLimitByName('translation');
    // },
    // getRekognitionLimit: function() {
    //   return this.getLimitByName('rekognition');
    // },

    getAddonByName: function() {
      return (name) => {
        if (this.getSubscription &&
            this.getSubscription.addons &&
            this.getSubscription.addons[name]) {
          return this.getSubscription.addons[name];
        }

        return null;
      }
    },
    getUserAddon: function() {
      return this.getAddonByName('users');
    },
    getClientuserAddon: function() {
      return this.getAddonByName('clientuser');
    },
    getStorageAddon: function() {
      return this.getAddonByName('storage');
    },
    getBandwidthAddon: function() {
      return this.getAddonByName('bandwidth');
    },
    getCreditsAddon: function() {
      return this.getAddonByName('credits');
    },
    // getTranscriptAddon: function() {
    //   return this.getAddonByName('transcription');
    // },
    // getTranslateAddon: function() {
    //   return this.getAddonByName('translation');
    // },

    // getRekognitionAddon: function() {
    //   return this.getAddonByName('rekognition');
    // },

    isSubmitDisabled: function() {
      return !this.getLimits ||
        !this.getSubscription ||
        !this.getSubscription.addons ||
        (
          this.usersItems == 0 &&
          this.clientuserItems == 0 &&
          this.storageItems == 0 &&
          this.bandwidthItems == 0 &&
          this.creditItems == 0
          // this.transcriptItems == 0 &&
          // this.translateItems == 0 &&
          // this.rekognitionItems == 0
        );
    },
    isInTrialPeriod: function() {
      return  this.getSubscription &&
              this.getSubscription.interval &&
              this.getSubscription.interval == 'trial';
    }
  }

}
</script>

<style>
</style>
